import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApolloQueryResult } from '@apollo/client/core';
import * as gql from 'gql-query-builder';
import { GraphQlRequestService } from '@gelato-api-ui/core/api/services/graph-ql-request.service';
import { SubscriptionDiscounts, SubscriptionDiscountsResponse } from '../types/subscription-discounts';

@Injectable()
export class SubscriptionDiscountsApiService {
  constructor(private readonly graphQlRequestService: GraphQlRequestService) {}

  fetchSubscriptionDiscounts(): Observable<SubscriptionDiscounts> {
    const operation = 'subscriptionDiscounts';
    const query = gql.query({ operation, fields: ['shipping'] });

    return this.graphQlRequestService
      .query(query, operation)
      .pipe(map((data: ApolloQueryResult<SubscriptionDiscountsResponse>) => data?.data?.[operation]));
  }
}
